<template>
    <div class="Index">
      <div class="window_bg"></div>
      <div class="haerd">
        <div class="haerd_left">
          <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
          <div class="title">名师讲坛</div>
        </div>
      </div>
      <div class="deer"></div>
      <div class="module_box">
        <div class="kg" @click.stop.prevent="goZsxxw">
          <img class="icon" src="@/assets/threePages/zsxxw.png" alt="" />
          <div class="text">合肥终身学习网</div>
          <img class="arrow" src="@/assets/arrow_icon.png" alt="" />
        </div>
      </div>
      <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
    </div>
  </template>
  <script>
  export default {
    name: "index",
    data() {
      return {};
    },
    created() {},
  
    mounted() {},
    beforeDestroy() {},
  
    methods: {
      async goBack() {
        this.$router.replace({
          path: "/study/studyIndex",
        });
      },
      async goZsxxw() {
        this.$router.push({
          path: "/study/forum/zsxxw/index1",
        });
      },
    },
  };
  </script>
  
  <style scoped lang="less">
  .newTop {
    top: 280px !important;
  }
  .newpadding {
    padding: 36px 40px 0 !important;
  }
  .newmargin {
    margin-top: 30px !important;
  }
  .Index {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: linear-gradient(180.00deg, rgb(95, 141, 255) 6.107%,rgb(144, 181, 252) 39.695%,rgb(217, 240, 255) 99.237%);
    background-size: 100% 100%;
    border-radius: 0px;
    .window_bg {
      position: absolute;
      top: -50px;
      left: -50px;
      width: 630px;
      height: 684px;
      background: url("@/assets/colorBg/window_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
  .haerd {
    padding: 40px 30px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .haerd_left {
      position: relative;
      z-index: 1;
      .backBtn {
        cursor: pointer;
        width: 251px;
        height: 90px;
        background: url("@/assets/colorBg/backBtn.png") no-repeat center;
        background-size: 100% 100%;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 40px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
        border-radius: 96.5px;
        box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
      }
      .title {
        margin-top: 40px;
        // margin-left: 20px;
        font-family: SourceHanSansSC-Regular-2;
        font-weight: bold;
        font-size: 70px;
        width: 50vw;
        color: #ffffff;
        line-height: 1.2;
      }
    }
  }
  
  .deer {
    position: absolute;
    top: 130px;
    right: 80px;
    width: 282px;
    height: 300px;
    background: url("@/assets/study/studyIndex/deep.png")
      no-repeat center;
    background-size: 100% 100%;
  }
  .module_box {
    position: absolute;
    top: 430px;
    left: 50%;
    transform: translate(-50%);
    max-height: 730px;
    overflow-y: auto;
    padding: 0 10px;
    .kg {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      width: 606px;
      height: 150px;
  
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.1);
/* 绿色 */
background: linear-gradient(180.00deg, rgb(179, 240, 139),rgb(86, 198, 44) 60.305%,rgb(107, 214, 65) 96.183%);
      border-radius: 15px;
      margin-bottom: 25px;
      .icon {
        width: 90px;
        height: 90px;
        // margin: 0 60px;
      }
      .text {
        width: 60%;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 50px;
        color: #ffffff;
        // margin-right: 180px;
      }
      .arrow {
        width: 25px;
        height: 45px;
      }
    }
  
  }
  
  .prompt {
    width: 100%;
    position: absolute;
    bottom: 2vh;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 30px;
    color: #666666;
    text-align: center;
  }
  // }
  </style>
  